import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Pressable, Text, View } from 'react-native';
import { useSafeAreaFrame, useSafeAreaInsets } from 'react-native-safe-area-context';

const HeaderViewDown = ({
  setTimeFinished,
  isPlaying,
  handleEnd,
  objectsFound,
  maxAttempts,
  gameType,
  setRenderExitCard,
  time,
  setRenderRanking,
}) => {
  const insets = useSafeAreaInsets();
  const { height } = useSafeAreaFrame();

  const minutes = useMemo(() => {
    return Math.floor(time / 60);
  }, [time]);

  const seconds = useMemo(() => {
    const result = time - Math.floor(time / 60) * 60;

    return result.toString().length === 1 ? `0${result}` : result;
  }, [time]);

  useEffect(() => {
    if (time === 0) {
      setTimeFinished(true);
    }
  }, [time]);

  return (
    <View style={{ marginTop: insets.top + 0.02 * height, alignItems: 'center' }}>
      <View
        style={{
          marginTop: insets.top + 0.02 * height,
          flexDirection: 'row',
          alignItems: 'center',
          alignSelf: 'center',
        }}>
        {gameType === '' && (
          <Pressable
            onPress={() => {
              setRenderRanking(true);
            }}>
            <Text
              style={{ fontFamily: 'JetBrainsMono', fontSize: 0.018 * height, color: '#445780' }}>
              Ranking
            </Text>
          </Pressable>
        )}

        {gameType === 'play' && (
          <>
            <Text
              style={{ fontFamily: 'JetBrainsMono', fontSize: 0.018 * height, color: '#445780' }}>
              Encontre os objetos
            </Text>
            <Text
              style={{
                fontFamily: 'JetBrainsMono',
                fontSize: 0.021 * height,
                color: time > 10 ? '#445780' : '#B63939',
                marginLeft: 0.02 * height,
              }}>
              {minutes}:{seconds}
            </Text>
            <Text
              style={{
                fontFamily: 'JetBrainsMono',
                fontSize: 0.021 * height,
                color: '#445780',
                marginLeft: 0.02 * height,
              }}>
              {objectsFound}/{maxAttempts}
            </Text>
          </>
        )}
      </View>
      {gameType !== '' && (
        <Pressable
          style={{ marginTop: gameType === 'play' ? 10 : 0 }}
          onPress={() => {
            if (gameType === 'explore') {
              handleEnd();
            } else {
              setRenderExitCard(true);
            }
          }}>
          <Text style={{ fontFamily: 'JetBrainsMono', fontSize: 0.018 * height, color: '#445780' }}>
            {gameType === 'explore' ? 'Voltar' : 'Desistir'}
          </Text>
        </Pressable>
      )}
    </View>
  );
};

export default HeaderViewDown;
